import { AccesoAplicacion, AccesoAplicacionFav, AccesoAplicacionMarkable } from 'src/common/acceso';
import { EntityState, createEntityAdapter, EntityAdapter, Update } from '@ngrx/entity';
import { AplicacionActions, AplicacionActionTypes, CANT_CREATE_TOKEN, CANT_GET_ACCESO_DATE, CANT_GET_IP_CLIENTE, URL_NOT_FOUND } from './aplicacion.actions';


export interface AplicacionState extends EntityState<AccesoAplicacionFav> {
    ready: boolean;
	accesoUrl: string,
	accesoMfTokenPersona: string,
	accesoPortalAuditorToken: string,
	accesoDate: string,
	accesoIpCliente: string,
	accesoHceToken: string,
	accesoCredToken: string
}

export const aplicacionAdapter: EntityAdapter<AccesoAplicacionFav> = createEntityAdapter<AccesoAplicacionFav>();

const initialAplicacionState: AplicacionState = aplicacionAdapter.getInitialState({
    ready: true,
	accesoUrl: null,
	accesoMfTokenPersona: null,
	accesoPortalAuditorToken: null,
	accesoDate: null,
	accesoIpCliente: null,
	accesoHceToken: null,
	accesoCredToken: null
});

export function aplicacionReducer( state: AplicacionState = initialAplicacionState, action: AplicacionActions ): AplicacionState {
    let appId: number;
    let readyUpdate: Update<AccesoAplicacionFav>;
	let ipCliente: string;

    switch( action.type ) {
		case AplicacionActionTypes.AllAplicacionRequested:
			let actionPayload: Object = action["payload"];
	
			if( actionPayload["forceReload"] ) {
				state = aplicacionAdapter.removeAll( state );
			}
			return { ...state, ready: false };
		case AplicacionActionTypes.AllAplicacionLoaded:
			let payload: Object = action["payload"];
            let accesos: AccesoAplicacionFav[] = payload["accesos"];
			ipCliente = payload["ipCliente"];
            state = aplicacionAdapter.addMany( accesos, { ...state, ready: true, accesoIpCliente: ipCliente } );
			return aplicacionAdapter.updateMany(
				(state.ids as number[]).map( id => {
					return { id, changes: { markedFromUI: false } };
				}),
				state );
		case AplicacionActionTypes.AllAplicacionCancelled:
		case AplicacionActionTypes.AllAplicacionRight:
			return { ...state, ready: true };
        case AplicacionActionTypes.AplicacionToggleMarkedRequested:
            let acceso: AccesoAplicacionFav = action["payload"];
            readyUpdate = {
                id: acceso.id,
                changes: { ready: false }
            };
            return aplicacionAdapter.updateOne( readyUpdate, { ...state, ready: false } );
        case AplicacionActionTypes.AplicacionToggleMarkedLoaded:
            appId = action["payload"];
            const markedUpdate: Update<AccesoAplicacionFav> = {
                id: appId,
                changes: { marked: !state.entities[ appId ].marked, markedFromUI: true, ready: true }
            };
            return aplicacionAdapter.updateOne( markedUpdate, { ...state, ready: true } );
        case AplicacionActionTypes.AplicacionToggleMarkedCancelled:
            appId = action["payload"];
            readyUpdate = {
                id: appId,
                changes: { ready: true }
            }
            return aplicacionAdapter.updateOne( readyUpdate, { ...state, ready: true } );

		case AplicacionActionTypes.AplicacionFavInit:
			// Seteo todos las aplicaciones con markedFromUI en false
			return aplicacionAdapter.updateMany(
				(state.ids as number[]).map( id => {
					return { id, changes: { markedFromUI: false } };
				}),
				state );

		// Acceso related actions
		case AplicacionActionTypes.AccesoUrlRequested:
			return { ...state, accesoUrl: null };
		case AplicacionActionTypes.AccesoUrlLoaded:
			return { ...state, accesoUrl: action["payload"]["url"] };
		case AplicacionActionTypes.AccesoUrlCancelled:
			return { ...state, accesoUrl: URL_NOT_FOUND };

		case AplicacionActionTypes.MFTokenPersonaRequested:
			return { ...state, accesoMfTokenPersona: null };
		case AplicacionActionTypes.MFTokenPersonaLoaded:
			return { ...state, accesoMfTokenPersona: action["payload"]["token"] };
		case AplicacionActionTypes.MFTokenPersonaCancelled:
			return { ...state, accesoMfTokenPersona: CANT_CREATE_TOKEN };

		case AplicacionActionTypes.AccesoDateRequested:
			return { ...state, accesoDate: null };
		case AplicacionActionTypes.AccesoDateLoaded:
			return { ...state, accesoDate: action["payload"]["date"] };
		case AplicacionActionTypes.AccesoDateCancelled:
			return { ...state, accesoDate: CANT_GET_ACCESO_DATE };

		case AplicacionActionTypes.PortalAuditorTokenRequested:
			return { ...state, accesoPortalAuditorToken: null };
		case AplicacionActionTypes.PortalAuditorTokenLoaded:
			return { ...state, accesoPortalAuditorToken: action["payload"]["token"] };
		case AplicacionActionTypes.PortalAuditorTokenCancelled:
			return { ...state, accesoPortalAuditorToken: CANT_CREATE_TOKEN };

		case AplicacionActionTypes.IpClienteRequested:
			ipCliente = state.accesoIpCliente == CANT_GET_IP_CLIENTE? null: state.accesoIpCliente;
			return { ...state, accesoIpCliente: ipCliente };
		case AplicacionActionTypes.IpClienteLoaded:
			ipCliente = action["payload"]["ipCliente"];
			return { ...state, accesoIpCliente: ipCliente };
		case AplicacionActionTypes.IpClienteCancelled:
			return { ...state, accesoIpCliente: CANT_GET_IP_CLIENTE };

		case AplicacionActionTypes.HCETokenRequested:
			return { ...state, accesoHceToken: null };
		case AplicacionActionTypes.HCETokenLoaded:
			return { ...state, accesoHceToken: action["payload"]["token"] };
		case AplicacionActionTypes.HCETokenCancelled:
			return { ...state, accesoHceToken: CANT_CREATE_TOKEN };

		case AplicacionActionTypes.CredTokenRequested:
			return { ...state, accesoCredToken: null };
		case AplicacionActionTypes.CredTokenLoaded:
			return { ...state, accesoCredToken: action["payload"]["token"] };
		case AplicacionActionTypes.CredTokenCancelled:
			return { ...state, accesoCredToken: CANT_CREATE_TOKEN };

        default:
            return state;
    }
}

export const {
    selectAll
} = aplicacionAdapter.getSelectors();